import React from "react";
import FaqSearch from "../../components/Help/FaqSearch";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import { PageHeader, PageShell } from "../../components/UI/Page";

const Help = () => {
  return (
    <div className="app-canvas min-h-[calc(100vh-140px)] w-full">
      {/* Capped and centered rather than edge-to-edge: on a wide monitor a
          full-bleed column of questions leaves the text stranded against the
          bezels and makes each row hard to scan back to. */}
      <PageShell size="md">
        <PageHeader
          icon={HelpOutlineRoundedIcon}
          tone="rose"
          eyebrow="Everyday Tools"
          title="Help"
          description={
            <>
              Search for whatever you're trying to do — "web lead",
              "forklift", "dark mode" — and click a question to see the
              answer. You can also filter by area. If you don't find what you
              need, contact HelpDesk and we'll be happy to help.
            </>
          }
          actions={
            <a
              className="app-btn app-btn-secondary"
              href={`mailto:helpdesk@bigclumber.com?subject=Node%20Web%20Help%20Desk%20Ticket%20`}
            >
              Submit a Ticket
              <ArrowOutwardIcon sx={{ fontSize: 17 }} />
            </a>
          }
        />

        <FaqSearch />
      </PageShell>
    </div>
  );
};

export default Help;
